import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './style.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { runLayoutDebug } from './utils/layoutDebug';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

/* 로컬 점검 전용: npm start(개발 모드)에서 /__dev/book-purchases 로 열면 로그인 없이 [교재 발주 관리]만 띄웁니다.
   그 화면은 개발 모드에서 실제 DB 가 아니라 북스 로컬 서버(localhost:8788)의 모의 주문·모의 발주만 읽고 씁니다.
   배포 빌드에서는 NODE_ENV 가 production 이라 이 분기 자체가 빠집니다. */
const devHarness = process.env.NODE_ENV === 'development' && window.location.pathname === '/__dev/book-purchases';
if (devHarness) {
  const BookPurchases = React.lazy(() => import('./features/BookPurchases'));
  root.render(
    <StrictMode>
      <React.Suspense fallback={null}>
        <div className="max-w-6xl mx-auto p-4 md:p-8">
          <BookPurchases currentUser={{ id: 'local-admin', name: '관리자(로컬 점검)', role: 'admin' }} />
        </div>
      </React.Suspense>
    </StrictMode>
  );
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

// 주소 끝에 ?debug=layout 을 붙였을 때만 동작합니다. 평소에는 아무 일도 하지 않습니다.
runLayoutDebug();

// PWA 기능을 위해 서비스 워커를 등록합니다.
serviceWorkerRegistration.unregister();